export default "__VITE_ASSET__5532db34__"